
export function ConditionsOnCustomFieldsBoxViewConstructor(services, callbacks, context) {

  let joint = services.joint;


  return joint.shapes.html.AbstractBoxElementView.extend({
    isElementEditable: true,
    editElementModalController: 'chooseConditionsOnCustomFieldsController',
    editElementModalTemplate: require('./choose-conditions-on-custom-fields.modal.html'),
    angularTemplate: `
      <div layout="column">
          <span> {{elementView.boxDescription}} </span>
      </div>
      `,
    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
      this._updateDescription(this.angularScope.elementData);
      this.updateValidity();
    },
    afterEditElement: function (oldElementData, newElementData) {
      this._updateDescription(newElementData);
      this.updateValidity();
    },

    _updateDescription: function (elementData) {
      let customFieldEnable = false;
      try {
        customFieldEnable = context.customFieldsMap.has(elementData.selectedCustomField);
      } catch {
        customFieldEnable = false;
      }
      if (elementData?.selectedCustomField && !customFieldEnable) {
        this.angularScope.elementData = null;
        this.boxDescription = services.AngularTranslateService.instant('parameters/quick_replies/details/custom_field_removed');
      } else {
        if (elementData) {
          this.boxDescription = services.AngularCustomFieldsService.updateDescription(elementData, context.customFieldsMap);
        } else {
          this.boxDescription = services.AngularTranslateService.instant('parameters/quick_replies/details/add_a_custom_field');
        }
      }
    },

    updateValidity: function () {
      if (!this.angularScope || !this.angularScope.elementData) {
        this.model.setBoxValid(false);
      } else {
        const { selectedCustomField } = this.angularScope.elementData
        const valid = selectedCustomField && context.customFieldsMap.has(selectedCustomField);
        this.model.setBoxValid(valid);
      }
    },
  });
}

